// Messages

export const MSG_INIT_APP = "Initializing app";
export const MSG_DOWNLOAD_LOADING = "Downloading";
export const MSG_VIEW_CHART_VALIDATE_LOADING = "Validating";
export const MSG_VIEW_CHART_LOADING = "Fetching data and drawing chart";
export const MSG_DOWNLOAD_IMAGE_TITLE = "CME Liquidity Tool";
export const MSG_DOWNLOAD_IMAGE_SUB_TITLE = "Data Science";
export const MSG_DOWNLOAD_IMAGE_TOOL_URL = " (www.cmegroup.com/liquiditytool)"
export const MSG_DOWNLOAD_IMAGE_COPYRIGHT = "CME Group. All rights reserved.";
export const MSG_LOT_SIZE_MAX_4 = "Select up to 4 lot sizes";
export const MSG_LOT_SIZE_MAX_1 = "Select only 1 lot size";

// Error Messages

export const MSG_ERR_INVALID_CHART_DATA = "No data was found for the selected filter options.";
export const MSG_ERR_VIEW_CHART_VALIDATION = "Looks like you missed a required filter option.";
export const MSG_ERR_VIEW_CHART_NO_DATA = "There's no data available for the chart.";
export const MSG_ERR_SERVER_GENERIC = "Something went wrong at the server.";
export const MSG_ERR_DOWNLOAD_NOT_SUPPORTED = "Download feature is not supported on this browser. Please try on Google Chrome";
export const MSG_ERR_DATE_RANGE_INVALID = "Start date should be less than end date";

// CHART LABELS

export const CHART_LABEL_TIME = "Time";
export const CHART_LABEL_MID_PRICE = "Mid Price";
export const CHART_LABEL_QUANTITY = "Quantity";
export const CHART_LABEL_COST_TICKS = "Cost (In Ticks)";
export const CHART_LABEL_SPREAD_TICKS = "Spread (In Ticks)";

// TOOLTIPS

export const TOOLTIP_PRODUCT = "Select a product to view its liquidity with the most active contract (product wise)";
export const TOOLTIP_START_DATE = "Start date for the liquidity time series";
export const TOOLTIP_END_DATE = "End date for the liquidity time series";
export const TOOLTIP_TIMEZONE_COMMON = "Trading hours in local time";
export const TOOLTIP_TIMEZONE = "'s trading hours in local time";
export const TOOLTIP_CTT =
  "Cost to Trade gives the ‘Cost to Buy’ and ‘Cost to Sell’ in ticks to immediately execute a single order of various lot sizes. 1 tick = minimum increment value as per the contract specs";
export const TOOLTIP_SPREAD =
  "Bid Ask Spread can be viewed up to 10 levels in order book. Each tick is decimalized converted as per the contract specs. 1 tick = minimum increment value";
export const TOOLTIP_BID_ASK_QUANTITY = "Book Depth can be viewed up to 10 levels deeper in order book";
export const TOOLTIP_LOT_SIZE = "Cost To Trade for various lot sizes";
export const TOOLTIP_COMPARE_WITH = "Overlay another analysis over the selected analysis";
export const TOOLTIP_VIEW_CHART = "Click to load the liquidity chart";
export const TOOLTIP_DOWNLOAD_IMAGE = "Download the chart in an image format (currently available only in Google Chrome)";
export const TOOLTIP_GRANULARITY_DAY = "Per day";
export const TOOLTIP_GRANULARITY_WEEK = "Per business week (Mon – Fri)";
export const TOOLTIP_GRANULARITY_MONTH = "Per financial month (from first to end of the month)";
export const TOOLTIP_GRANULARITY_QUARTER = "Per financial quarter";
export const TOOLTIP_GRANULARITY_YEAR = "Per financial year";
export const TOOLTIP_LAYER_BUY = "Cost to Buy for the selected lot size";
export const TOOLTIP_LAYER_SELL = "Cost to Sell for the selected lot size";
export const TOOLTIP_LAYER_TREND_LINES = "The trend of Cost to Buy/Sell across the selected time series";
export const TOOLTIP_LAYER_MID_PRICE = "The average of Bid & Ask price represented in U.S. Dollars";
export const TOOLTIP_LAYER_TOPOFTHEBOOK = "Top of the Book (Level 1) in market order book";
export const TOOLTIP_LAYER_TOP3LEVELS = "Top 3 levels in market order book";
export const TOOLTIP_LAYER_TOP5LEVELS = "Top 5 levels in market order book";
export const TOOLTIP_LAYER_TOP10LEVELS = "Top 10 levels in market order book";
export const TOOLTIP_ENLARGE = "View the chart in an enlarged view";
export const TOOLTIP_FEEDBACK = "Please provide your feedback on the Liquidity tool";
export const TOOLTIP_ADD_SECOND_CHART = "Add a second chart below to compare another analysis in parallel";
export const TOOLTIP_REMOVE_SECOND_CHART = "Remove the second chart from the this page";

// EMAIL

export const EMAIL_DATA_SCIENCE = "datascience@cmegroup.com";
export const MAILTO_DATA_SCIENCE = "mailto:" + EMAIL_DATA_SCIENCE + "?Subject=CME%20Liquidity%20FAQandHelp";



// WEBPACK FOOTER //
// ./src/services/managers/string-literals.js